// Shared pagination types and helpers for all paginated hooks.
// The hook's `select` guarantees this shape — pages receive clean data with no fallbacks.

export interface PaginatedResult<T> {
  data: T[]
  total: number
  page: number
  limit: number
  totalPages: number
  /**
   * Total rows in scope BEFORE any filter was applied (workspace-scoped,
   * deleted_at IS NULL). Used by list-page empty-state branching:
   *
   *   total === 0 && unfilteredTotal === 0 → "no recipients yet" empty state
   *                                          (truly empty workspace)
   *   total === 0 && unfilteredTotal > 0   → "no matches — clear filters"
   *                                          (filtered-empty)
   *
   * BE source: PaginatedResult<T> in admin-backend's
   * common/dto/paginated-list.query.ts. Optional for backwards compat
   * with modules that haven't migrated yet.
   */
  unfilteredTotal?: number
}

export function emptyPage<T>(limit = 25): PaginatedResult<T> {
  return { data: [], total: 0, page: 1, limit, totalPages: 1, unfilteredTotal: 0 }
}
